import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

const rootElement = document.getElementById('root');
const app = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// The post-build prerender serializes a browser-rendered DOM rather than
// React server markup. That preserves the content for scrapers, but it does
// not preserve React's hydration markers between adjacent text nodes. Clear
// the static copy before mounting so the interactive app starts cleanly
// without recoverable hydration errors.
rootElement.replaceChildren();
ReactDOM.createRoot(rootElement).render(app);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
